export type ListOfErrors = Array<string | null | undefined> | null | undefined

export function ErrorList({
  id,
  errors,
}: {
  errors?: ListOfErrors
  id?: string
}) {
  const errorsToRender = errors?.filter(Boolean)
  if (!errorsToRender?.length) return null

  return (
    <ul id={id} className="flex flex-col gap-1 px-2">
      {errorsToRender.map(error => (
        <li
          key={error}
          className="text-[11px] font-bold text-foreground-destructive"
        >
          {error}
        </li>
      ))}
    </ul>
  )
}
